<template>
  <div class="body-box" style="margin-top: 50px">
    <el-row>
      <el-col :span="24">
        <Editor :type="'html'"></Editor>
      </el-col>
    </el-row>
  </div>

</template>

<script>
import Editor from '@/components/common/editor/editor'

export default {
  components: {
    Editor
  },
  data() {
    return {}
  },
  mounted() {

  },
  methods: {

  }
}
</script>

<style lang="less" scoped>
.home {
  width: 1200px;
  margin: auto;
  position: relative;

  .btn {
    position: absolute;
    right: 0;
    top: 0;
    padding: 5px 10px;
    cursor: pointer;
  }

  h3 {
    margin: 30px 0 15px;
  }
}
</style>
